// src/pages/AdminSearchIndex.jsx
import React, { useState } from "react";
import { rebuildSearchIndex } from "../services/searchIndexAdmin";

export default function AdminSearchIndex() {
  const [wipe, setWipe] = useState(false);
  const [onlyActive, setOnlyActive] = useState(true);
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState(null);
  const [err, setErr] = useState("");

  const onRun = async () => {
    setErr(""); setResult(null); setRunning(true);
    try {
      const r = await rebuildSearchIndex({ wipe, onlyActive });
      setResult(r);
    } catch (e) {
      setErr(e?.message || "Échec de la reconstruction.");
    } finally {
      setRunning(false);
    }
  };

  return (
    <div className="container py-4" style={{ maxWidth: 780 }}>
      <h4 className="mb-3">Rebuild de l’index de recherche</h4>

      <div className="card shadow-sm">
        <div className="card-body">
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              id="wipe"
              type="checkbox"
              checked={wipe}
              onChange={() => setWipe(w => !w)}
            />
            <label className="form-check-label" htmlFor="wipe">
              Supprimer l’index existant avant (wipe)
            </label>
          </div>

          <div className="form-check mb-3">
            <input
              className="form-check-input"
              id="onlyActive"
              type="checkbox"
              checked={onlyActive}
              onChange={() => setOnlyActive(v => !v)}
            />
            <label className="form-check-label" htmlFor="onlyActive">
              N’indexer que les produits actifs
            </label>
          </div>

          <button className="btn btn-primary" disabled={running} onClick={onRun}>
            {running ? "Reconstruction en cours…" : "Reconstruire l’index"}
          </button>

          {err && <div className="alert alert-danger mt-3">{err}</div>}

          {result && (
            <div className="alert alert-success mt-3">
              <div className="mb-1 fw-semibold">Index reconstruit !</div>
              <div className="small text-muted">
                {result.wiped ? "Nettoyage effectué puis ajout." : "Ajout sans nettoyage."}
              </div>
              <ul className="mt-2 mb-0">
                <li>Produits indexés : {result.counts.products}</li>
                <li>Catégories indexées : {result.counts.categories}</li>
                <li>Marques indexées : {result.counts.brands}</li>
                <li>Total écrit : {result.counts.indexed}</li>
              </ul>
            </div>
          )}
        </div>
      </div>

      <p className="text-muted small mt-3">
        Astuce : si la recherche ne renvoie rien, vérifie les règles Firestore et que des documents existent bien
        dans <code>products</code>, <code>categories</code> et <code>brands</code>.
      </p>
    </div>
  );
}
